"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Plus = function Plus(_ref) {
  var color = _ref.color,
      width = _ref.width,
      lineCap = _ref.lineCap,
      lineJoin = _ref.lineJoin;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: width,
    strokeLinecap: lineCap,
    strokeLinejoin: lineJoin
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
};

Plus.propTypes = {
  color: _propTypes.default.string,
  width: _propTypes.default.string,
  lineCap: _propTypes.default.string,
  lineJoin: _propTypes.default.string
};
Plus.defaultProps = {
  color: '#000000',
  width: 'initial',
  lineCap: 'initial',
  lineJoin: 'initial'
};
var _default = Plus;
exports.default = _default;